<template>
  <div id="UpdateRates" class="update-rates-view">
    <Header></Header>
    <b-container fluid>
      <b-row>
        <CompetitorLeftNav></CompetitorLeftNav>
        <b-col>
          <b-row class="justify-content-start mt-5 mb-3">
            <b-col class="pl-sm-5 col">
              <h4>
                Update call rates
              </h4>
              <p>
                This process takes approximately 30 minutes.
              </p>
              <div>
                <b-button variant="success" class="icon-container" @click.prevent="update" :disabled="isLoading">
                  <i class="material-icons">refresh</i>
                  <span>Update</span>
                </b-button>
              </div>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import CompetitorLeftNav from '@/components/layout/CompetitorLeftNav'
import Header from '@/components/layout/Header'
import { mapGetters } from 'vuex'
export default {
  name: 'Rates',
  components: {
    CompetitorLeftNav,
    Header
  },
  methods: {
    update () {
      var api = process.env.COMPETITOR_API + '/v1/callingcorridors/update'
      window.open(api)
    }
  },
  computed: {
    ...mapGetters({
      'isLoading': 'loader/isLoading'
    })
  }
}
</script>
<style lang="scss" scoped>
.message{
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/competitor/UpdateRates.vue